module.exports = __webpack_public_path__ + "static/media/city-center.6b4891ea.jpg";